export const defaultDslSource = '';
export const defaultFieldsDataJson = `{
  "values": {}
}`;
export const defaultContextDataJson = `{}`;
export const defaultTranslationsJson = `{}`;
export const defaultStyling = '';
